
import React from 'react';
import { ExternalLink } from 'lucide-react';
import { format } from 'date-fns';
import { pl, enUS } from 'date-fns/locale';
import { useLanguage } from '@/hooks/useLanguage';

interface NewsItemProps {
  news: {
    title: string;
    link: string;
    pubDate?: string;
    date?: string;
    source?: string;
  };
}

export function NewsListItem({ news }: NewsItemProps) {
  const { language, t } = useLanguage();
  
  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      
      return format(date, 'dd MMM yyyy', {
        locale: language === 'pl' ? pl : enUS,
      });
    } catch (error) {
      console.error("Error formatting date:", error);
      return dateString;
    }
  };

  // Use pubDate if available, otherwise try date
  const displayDate = formatDate(news.pubDate || news.date);

  return (
    <div className="group">
      <a 
        href={news.link} 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex flex-col group-hover:text-primary transition-colors"
      >
        <div className="flex justify-between items-center">
          <h3 className="font-medium line-clamp-1 group-hover:underline">{news.title}</h3>
          <ExternalLink className="h-3 w-3 opacity-0 group-hover:opacity-100 transition-opacity" />
        </div>
        <div className="flex justify-between text-xs text-muted-foreground">
          <span>{news.source || t('common.unknown_source')}</span>
          <span>{displayDate}</span>
        </div>
      </a>
    </div>
  );
}
